module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_suns_white-4f47497ccfde44da228111ce492a7f67.svg";